"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AbstractButton = _interopRequireDefault(require("./AbstractButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Spinner = require("./spinner").default;
const Tooltip = require("./tooltip").default;
var _default = exports.default = (0, _AbstractButton.default)('Button', (classes, props) => {
  const style = {
    paddingRight: props.loading ? 32 : undefined,
    transition: 'padding 0.2s'
  };
  const b = /*#__PURE__*/_react.default.createElement("span", {
    style: {
      position: 'relative'
    },
    className: "hidden-print"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-test-id": props['data-test-id'],
    type: "button",
    style: props.style ? Object.assign(style, props.style) : style,
    className: classes.join(' '),
    disabled: props.disabled || props.loading,
    onClick: props.onClick
  }, props.children, !props.loading ? '' : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      right: 0,
      top: '50%'
    }
  }, /*#__PURE__*/_react.default.createElement(Spinner, {
    dark: props.type === 'secondary'
  }))));
  if (props.title || props.overlay) {
    return /*#__PURE__*/_react.default.createElement(Tooltip, {
      overlay: props.title || props.overlay,
      trigger: ['hover', 'click']
    }, b);
  }
  return /*#__PURE__*/_react.default.createElement("span", null, b);
}, {
  type: 'secondary'
});